import { callApi } from "repoV2/utils/common/api/callApi";
import { appendURLSearchParams } from "repoV2/utils/urls&routing/urlParams";
import {
    CHECKOUT_PAGE_DETAILS_API_ENUMS,
    PAGE_SOURCES_VALUES,
} from "repoV2/features/CheckoutPages/constants/CheckoutPages.constants";
import { checkout_pages_api } from "../CheckoutPages.api";
import { ICreatorDetailsApiResponse } from "./ICreatorDetailsApi.interface";

/**
 * This api is to get the checkout page data for the default section and
 * the creator details modules
 * @param object An object containing hostName, and the listing slug or uuid
 * @returns api response
 */
export const callGetcreatorDetailsApi = ({
    hostName,
    listingSlug,
    dynamicLinkUuid,
}: {
    hostName: string;
    listingSlug: string;
    dynamicLinkUuid: string;
}) =>
    callApi({
        url: `${
            checkout_pages_api.checkout_page_details
        }/${hostName}/${listingSlug}${appendURLSearchParams("", {
            section: CHECKOUT_PAGE_DETAILS_API_ENUMS.CREATOR_DETAILS_SECTION,
            page_source: PAGE_SOURCES_VALUES.CHECKOUT_PAGE,
            ...(dynamicLinkUuid && {
                dynamic_link_id: dynamicLinkUuid,
            }),
        })}`,
        extraOptions: {
            appendExlyBackendHeaders: true,
        },
    }).then((response: ICreatorDetailsApiResponse) => {
        const {
            [CHECKOUT_PAGE_DETAILS_API_ENUMS.CREATOR_DETAILS_SECTION]:
                creatorDetails,
        } = response?.data?.data || {};

        return creatorDetails;
    });
